module.exports = __webpack_public_path__ + "img/20220216_153213.b8d58c9e.jpg";